const userMenuItems = [];

export default userMenuItems;

export const sidebarWrapperHeight = 'calc(100vh - 115px)';